import { useAppContext } from '@contexts/app/hooks/useAppContext';
import { DevicePlatformId } from '@utils/DevicePlatformId';

export const useIsMobile = () => {
    const { devicePlatformId, appId } = useAppContext();

    // TODO: for making sure MSPA always apply mobile
    return devicePlatformId === DevicePlatformId.PHONE || appId === 'mspa';
};
